var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { MarketingPreferenceItemWrapper, MarketingPreferenceWrapper } from './subcomponents';
import MarketingPrivacySettingItem from './MarketingPrivacySettingsItem';
import { marketingPrivacySettingsCategories } from '../config';
import { useFeatureFlag } from '../../../context/FeatureFlag';
import setFeatureFlags from '../../../context/FeatureFlag/setFeatureFlags';
var MarketingPreferences = function (_a) {
    var marketingSettingsData = _a.marketingSettingsData, accountId = _a.accountId, config = _a.config;
    var _b = useState(null), openedAccordion = _b[0], setOpenedAccordion = _b[1];
    var _c = useFeatureFlag(), featureFlags = _c.state, dispatchFeatureFlag = _c.dispatch;
    var categoryList = Object.keys(marketingPrivacySettingsCategories).filter(function (category) { var _a; return featureFlags[(_a = marketingPrivacySettingsCategories[category]) === null || _a === void 0 ? void 0 : _a.flagName]; });
    useEffect(function () {
        setFeatureFlags(dispatchFeatureFlag);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (_jsx(MarketingPreferenceWrapper, __assign({ "data-test": "MarketingPrivacySettings" }, { children: categoryList.map(function (categoryKey) { return (_jsx(MarketingPreferenceItemWrapper, { children: _jsx(MarketingPrivacySettingItem, { categoryKey: categoryKey, openedAccordion: openedAccordion, setOpenedAccordion: setOpenedAccordion, marketingSettingsData: marketingSettingsData, accountId: accountId, config: config }, categoryKey) }, categoryKey)); }) })));
};
export default MarketingPreferences;
